import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import LZString from 'lz-string';

export default {
    name: 'FooterAgent',

    props: ['agent'],

    data() {
        return {
            isMobile: window.innerWidth <= 991,
            intervener: undefined,
            intervenerAgent: undefined,
            publicBucketURL: process.env.VUE_APP_S3_PUBLIC_BUCKET_URL,
            subdistributor: undefined
        };
    },

    async mounted() {
        const raw = localStorage.getItem('PACOUS');
        let localStorageData;

        if (raw) {
            try {
                const decompressed = LZString.decompressFromUTF16(raw);
                if (decompressed) {
                    localStorageData = decompressed;
                } else {
                    // Fallback al formato base64 antiguo
                    localStorageData = decodeURIComponent(escape(window.atob(raw)));
                }
            } catch (e) {
                console.error('❌ Error al descomprimir PACOUS:', e);
                localStorageData = null; // Fallback en caso de error
            }
        }

        if (
            localStorageData &&
            JSON.parse(localStorageData).private_area &&
            JSON.parse(localStorageData).private_area.intervener
        ) {
            this.intervener = JSON.parse(localStorageData).private_area.intervener;

            if (
                this.intervener &&
                this.intervener.uuid_distributor === '6b4e3e9b-0e7f-494a-bdc9-0818eaf61e02' &&
                this.intervener.uuid_subdistributor
            ) {
                const subdistributorRes = await this.$userService.getSubdistributorInfo(
                    this.intervener.uuid_subdistributor
                );
                this.subdistributor = subdistributorRes.data.subdistributor;
            }

            const agent_data = await this.$intervenerService.getIntervenerAgent(
                this.intervener.uuid_agent
            );
            this.intervenerAgent = agent_data.data;
        }
    },
    computed: {
        currentUser() {
            const raw = localStorage.getItem('PACOUS');
            let user;

            try {
                const decompressed = LZString.decompressFromUTF16(raw);
                if (decompressed) {
                    user = JSON.parse(decompressed).user;
                } else {
                    // Fallback al formato base64 antiguo
                    user = JSON.parse(decodeURIComponent(escape(window.atob(raw)))).user;
                }
            } catch (e) {
                console.error('❌ Error al descomprimir PACOUS:', e);
                user = {}; // Fallback en caso de error
            }

            return `${user.given_name} ${user.family_name_1}`;
        },
        hasAgent() {
            if (this.intervener && this.intervener.uuid_agent) {
                return true;
            }
        },
        agentPhone() {
            if (this.intervenerAgent) {
                const firstNumbersPhone = this.intervenerAgent.telephone.slice(0, 2);
                let prefix = '';
                if (firstNumbersPhone != '90') {
                    prefix = '+34 ';
                }
                return `${prefix}${this.intervenerAgent.telephone}`;
            }
        },
        hasNoCobasDistributor() {
            if (
                this.intervener &&
                this.intervener.uuid_distributor !== '6b4e3e9b-0e7f-494a-bdc9-0818eaf61e02'
            ) {
                return true;
            }
        },
        hasCobasSubdistributor() {
            if (
                this.intervener &&
                this.intervener.uuid_distributor === '6b4e3e9b-0e7f-494a-bdc9-0818eaf61e02' &&
                this.intervener.uuid_subdistributor
            ) {
                return true;
            }
        },
        showAgent() {
            return this.hasAgent && this.intervenerAgent && !this.hasNoCobasDistributor;
        }
    },

    methods: {
        navigateToWeb(url, method) {
            try {
                if (!Capacitor.isNativePlatform()) {
                    window.open(url);
                    return;
                }
                this.ref = window.cordova.InAppBrowser.open(
                    url,
                    method,
                    'location=no,beforeload=yes,'
                );
                this.ref.addEventListener('beforeload', (params, callback) => {
                    callback(params.url);
                });
            } catch (err) {
                window.open(url);
                return;
            }
        },
        openExternalLink(url) {
            if (!Capacitor.isNativePlatform()) {
                window.open(url);
                return;
            }

            return Browser.open({ url: encodeURI(url) });
        },

        handleContactForm() {
            if (this.$route.path !== '/contact') {
                if (this.hasAgent) {
                    this.$router.push({ name: 'Contact' });
                } else {
                    let url = process.env.VUE_APP_CONTACT_FORM_URL;
                    this.navigateToWeb(url, '_self');
                }
            }
        },
        openLinkedin() {
            this.navigateToWeb('https://www.linkedin.com/company/cobas-asset-management', '_blank');
        },
        openTwitter() {
            this.navigateToWeb('https://twitter.com/CobasFunds', '_blank');
        }
    }
};
